import { createFileRoute } from '@tanstack/react-router'

import { PasswordCreation } from '@/containers/Account'

export const Route = createFileRoute(
  '/_unauthenticated/setup/password-creation'
)({
  component: PasswordCreation,
})
